export default "__VITE_ASSET__MaFeg$Ov__"